import { useGetAreaBaseBlocksQuery } from 'features/documents/documents';
import { useContext } from 'react';
import { AreaContext } from 'pages/documents_v2/views/edit_area/context/AreaContext';
import { useGetAreaId } from 'pages/documents_v2/views/edit_area/hooks/useGetAreaId';

const emptyArray = [];

export function useGetAreaBaseBlocks() {
    const areaId = useGetAreaId();
    const { activeVariantId } = useContext(AreaContext);

    return useGetAreaBaseBlocksQuery(
        { areaId, variantId: activeVariantId },
        {
            selectFromResult: ({ currentData, isUninitialized, isLoading, isFetching }) => {
                const items = currentData ?? emptyArray;

                return {
                    baseBlocks: items,
                    isEmpty: items.length === 0 && !isUninitialized && !isLoading && !isFetching,
                    isLoading: isUninitialized || (isFetching && items.length === 0),
                };
            },
            skip: activeVariantId === 0,
        },
    );
}
